// @vendor
const React = require('react');
// @utilities
import { FormattedText, formatText } from 'core/i18n';

const NotRecommendedMessage = () => {
    return (
        <div className="message-box yellow-box">
            <i className="icons icons--icon-alert-yellow"></i>
            <h6 className="font-heading6">{formatText('identity-noticeTitle')}</h6>
            <p className="font-paragraph2">
                <FormattedText value="identity-notRecommendedMessage" />
            </p>
        </div>
    );
};

export { NotRecommendedMessage };
